import { Injectable } from "@angular/core";
import { DataService } from "./data.service";

@Injectable()
export class PaccsbookingService {
  constructor(private dataService: DataService) {}
  getdealerlist(data: any, refresh: boolean) {
    return this.dataService.getData(
      "/api/paccsbooking/getdealerlist/" +
        data.dbtManufacturerId +
        "/" +
        data.dbtProductId,
      refresh
    );
  }

getGoListbyId(financialYearId:any, Department:any, refresh:boolean ) {
    return this.dataService.getData('/api/paccsbooking/dbtgolist/' + financialYearId + '/' + Department, refresh);
}
getSchemaListbyId(refresh: boolean, id: number) {
  return this.dataService.getData('/api/paccsbooking/dbtschemelist/' + id, refresh);
}
getComponetListbyId(goId: number, dbtSchemeId: number, refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/dbtcomponentlist/' + goId + '/' + dbtSchemeId, refresh);
}
editdbtcomponentallList(goId: number, dbtSchemeId: number, refresh: boolean){
  return this.dataService.getData('/api/paccsbooking/dbtcomponentalllist/' + goId + '/' + dbtSchemeId, refresh)}
  
getManufacturerList(financialYearId:any,goId:any,componentId:any,refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/manufacturerof/'+financialYearId+'/'+goId+'/'+componentId, refresh
  );
}
getMachinaryClassificationList(financialYearId:any,goId:any,componentId:any,manufacturerType:any,refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/machinaryclassification/'+financialYearId+'/'+goId+'/'+componentId+'/'+manufacturerType, refresh
  );
}
getmachinarycategory(financialYearId:any,goId:any,componentId:any,manufacturerType:any,machinaryClassificationId:any,refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/machinarycategory/'+financialYearId+'/'+goId+'/'+componentId+'/'+manufacturerType+'/'+machinaryClassificationId, refresh
  );
}
getproductlist(financialYearId:any, goId :any,componentId:any,manufacturerType:any,machinaryCategoryId:any,refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/productlist/'+financialYearId+'/'+goId+'/'+componentId+'/'+manufacturerType+'/'+machinaryCategoryId, refresh
  );
}

getDashboardData(data:any,refresh:boolean){
  return this.dataService.getData('/api/paccsbooking/dashboard/'+ data.districtId +'/'+ data.blockId +'/'+ data.villageId +'/'+data.gramPanchayatId +'/'+ data.financialYearId+'/'+data.goId+'/'+data.schemeId, refresh);
}
// /api/paccsbooking/dashboarddrildown/{districtId}/{blockId}/{villageId}/{gramPanchayatId}/{financialYearId}/{goId}/{schemeId}/{componentId}

getDashboarddrildown(data:any, refresh: any){
  return this.dataService.getData('/api/paccsbooking/dashboarddrildown/' + data.districtId + '/' + data.blockId + '/' + data.villageId + '/' + data.gramPanchayatId + '/' + data.financialYearId + '/' + data.goId +'/' + data.schemeId + '/' + data.componentId, refresh)
}

getproductlistbymanufacturer(component: any, dbtProductId: any, financialYearId: any, refresh: boolean) {
  return this.dataService.getData('/api/paccsbooking/getproductlistbymanufacturer/' + component + '/' + dbtProductId + '/' + financialYearId,
    refresh
  );
}

paccspaymentsave(result: any){
  return this.dataService.post('/api/paccsbooking/paymentupdate', result).map(response => {
      return response;
  });
}
subsidyrelease(result: any){
  return this.dataService.post('/api/paccsbooking/eesubsidysave', result).map(response => {
      return response;
  });
}
dealerdeliverysave(result: any){
  return this.dataService.post('/api/paccsbooking/dealerdeliverysave', result).map(response => {
      return response;
  });
}
aeeinspectionsave(result: any){
  return this.dataService.post('/api/paccsbooking/aeeinspectionsave', result).map(response => {
      return response;
  });
}

getpaccslist(districtId: any, refresh){
  return this.dataService.getData('/api/paccsbooking/paccslist/' + districtId, refresh)
}
getPaacInfo(id,refresh){
  return this.dataService.getData('/api/paccsbooking/moreinfo/' + id, refresh)

}
getaeeandeedistrict(langType,refresh){
  return this.dataService.getData('/api/paccsbooking/aeeandeedistrict/' + langType, refresh)
}
getaeeandeeblock(districtId,langType,refresh){
  return this.dataService.getData('/api/paccsbooking/aeeandeeblock/' + districtId+'/'+ langType, refresh)
}
getPaccsBookingLookup(paccsBookingId:any, componentId:any, refresh){
  return this.dataService.getData('/api/paccsbooking/lookup/' + paccsBookingId + '/' +componentId, refresh)
}
getUpdatePaymentStatus(id:any)
{
  return this.dataService.post('/api/paccsbooking/targetcheckforcomponent',id)
}

placeOrder(data)
{
  return this.dataService.post('/api/paccsbooking/sanctionapproval',data)
}

}
